import React, { useState, useEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
  getEndOfMonth,
  GetSelectedIDsFromList,
  getStartOfMonth,
} from "../Shared/Utility";
import { useGlobalState } from "../Context/GlobalStateContext";
import { showErrorMessage } from "../Shared/Toast";
import ConfirmationModal from "../App/ConfirmationModal";

function MoveTypeServiceQuestionOption() {
  const globalState = useGlobalState();
  const [showModal, setShowModal] = useState(false);
  const [showRouteView, setShowRouteView] = useState(false);
  const [isAnimation, setIsAnimation] = useState(false);
  const [gridData, setGridData] = useState<any>([]);
  const [gridDataOptions, setGridDataOptions] = useState<any>([]);
  const [MNVMoveTypeServiceQuestionID, setMNVMoveTypeServiceQuestionID] =
    useState(0);
  const [MNVMoveTypeServiceID, setMNVMoveTypeServiceID] = useState(0);

  const [isAddNew, setIsAddNew] = useState(0);
  const [addEditObject, setAddEditObject] = useState<any>({
    MNVMoveTypeServiceQuestionID: 0,
    MNVMoveTypeServiceID: 0,
    Name: "",
    Description: "",
    PTOrderBy: 0,
  });

  const [isAddNewOptions, setIsAddNewOptions] = useState(0);
  const [addEditObjectOptions, setAddEditObjectOptions] = useState<any>({
    MNVMoveTypeServiceQuestionOption: 0,
    MNVMoveTypeServiceQuestionID: 0,
    Name: "",
    PTOrderBy: 0,
  });

  const [isAddNewPreRequisite, setIsAddNewPreRequisite] = useState(0);
  const [addEditObjectPreRequisite, setAddEditObjectPreRequisite] =
    useState<any>({
      MNVMoveTypeServiceQuestionPreRequisiteID: 0,
      MNVMoveTypeServiceQuestionID: 0,
      Name: "",
      Description: "",
      OptionIDs: "",
      OptionOperator: "",
      PTOrderBy: 0,
    });

  const [isAddNewRoutes, setIsAddNewRoutes] = useState(0);
  const [addEditObjectRoutes, setAddEditObjectRoutes] = useState<any>({
    MNVMoveTypeServiceRouteID: 0,
    MNVMoveTypeServiceID: 0,
    Name: "",
    Description: "",
    OptionIDs: "",
    OptionOperator: "",
    PTOrderBy: 0,
  });

  const [selectedQuestionName, setSelectedQuestionName] = useState("");

  useEffect(() => {
    GetMNVMoveTypeServiceQuestion();
  }, [MNVMoveTypeServiceID]);

  function GetMNVMoveTypeServiceQuestion() {
    setIsAnimation(true);
    let object = {} as any;
    object.MNVMoveTypeServiceID = MNVMoveTypeServiceID;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVMoveTypeServiceQuestion/GetMNVMoveTypeServiceQuestion",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          // console.log("GetMNVMoveTypeServiceQuestion", l_oResponse);
          setGridData(l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function GetMNVMoveTypeServiceQuestionOption(
    MNVMoveTypeServiceQuestionID: any,
  ) {
    setIsAnimation(true);
    let object = {} as any;
    object.MNVMoveTypeServiceQuestionID = MNVMoveTypeServiceQuestionID;
    setMNVMoveTypeServiceQuestionID(MNVMoveTypeServiceQuestionID);
    setIsAddNewOptions(0);
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVMoveTypeServiceQuestion/GetMNVMoveTypeServiceQuestionOption",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          // console.log("GetMNVMoveTypeServiceQuestionOption", l_oResponse);
          setGridDataOptions(l_oResponse);
          setShowModal(true);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation() {
    var IsOkay = true;
    if (
      !addEditObject.MNVMoveTypeServiceID ||
      addEditObject.MNVMoveTypeServiceID == 0
    ) {
      showErrorMessage("Please Question Type");
      IsOkay = false;
    } else if (!addEditObject.Name || addEditObject.Name == "") {
      showErrorMessage("Name Required");
      IsOkay = false;
    }

    if (IsOkay == true) {
      saveMNVMoveTypeServiceQuestionData();
    }
  }

  function saveMNVMoveTypeServiceQuestionData() {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvmovetypeservicequestionid =
      addEditObject.MNVMoveTypeServiceQuestionID;
    object.mnvmovetypeserviceid = addEditObject.MNVMoveTypeServiceID;
    object.name = addEditObject.Name;
    object.description = addEditObject.Description;
    object.ptorderby = addEditObject.PTOrderBy;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVMoveTypeServiceQuestion/MNVMoveTypeServiceQuestionSave",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          if (l_response && l_response[0] && l_response[0].Status == 0) {
            showErrorMessage(l_response[0].Message);
          } else {
            setIsAddNew(0);
            GetMNVMoveTypeServiceQuestion();
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteMNVMoveTypeServiceQuestionData(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvmovetypeservicequestionid = pid;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVMoveTypeServiceQuestion/MNVMoveTypeServiceQuestionDeleteRecord",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          GetMNVMoveTypeServiceQuestion();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidationOptions() {
    var IsOkay = true;
    if (!addEditObjectOptions.Name || addEditObjectOptions.Name == "") {
      showErrorMessage("Name Required");
      IsOkay = false;
    }

    if (IsOkay == true) {
      saveMNVMoveTypeServiceQuestionOptionSave();
    }
  }

  function saveMNVMoveTypeServiceQuestionOptionSave() {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvmovetypeservicequestionoptionid =
      addEditObjectOptions.MNVMoveTypeServiceQuestionOptionID;
    object.mnvmovetypeservicequestionid = MNVMoveTypeServiceQuestionID;
    object.name = addEditObjectOptions.Name;
    object.ptorderby = addEditObjectOptions.PTOrderBy;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVMoveTypeServiceQuestionOption/MNVMoveTypeServiceQuestionOptionSave",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          if (l_response && l_response[0] && l_response[0].Status == 0) {
            showErrorMessage(l_response[0].Message);
          } else {
            setIsAddNewOptions(0);
            GetMNVMoveTypeServiceQuestionOption(MNVMoveTypeServiceQuestionID);
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteMNVMoveTypeServiceQuestionOptionDeleteRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvmovetypeservicequestionoptionid = pid;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVMoveTypeServiceQuestionOption/MNVMoveTypeServiceQuestionOptionDeleteRecord",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          GetMNVMoveTypeServiceQuestionOption(MNVMoveTypeServiceQuestionID);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidationPreRequisite() {
    var IsOkay = true;
    if (
      !addEditObjectPreRequisite.Name ||
      addEditObjectPreRequisite.Name == ""
    ) {
      showErrorMessage("Name Required");
      IsOkay = false;
    }

    if (IsOkay == true) {
      saveMNVMoveTypeServiceQuestionPreRequisiteSave();
    }
  }

  function saveMNVMoveTypeServiceQuestionPreRequisiteSave() {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvmovetypeservicequestionprerequisiteid =
      addEditObjectPreRequisite.MNVMoveTypeServiceQuestionPreRequisiteID;
    object.mnvmovetypeservicequestionid = MNVMoveTypeServiceQuestionID;
    object.name = addEditObjectPreRequisite.Name;
    object.description = addEditObjectPreRequisite.Description;
    object.optionids = addEditObjectPreRequisite.OptionIDs;
    object.optionoperator = addEditObjectPreRequisite.OptionOperator;
    object.ptorderby = addEditObjectPreRequisite.PTOrderBy;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVMoveTypeServiceQuestionPreRequisite/MNVMoveTypeServiceQuestionPreRequisiteSave",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          if (l_response && l_response[0] && l_response[0].Status == 0) {
            showErrorMessage(l_response[0].Message);
          } else {
            setIsAddNewPreRequisite(0);
            GetMNVMoveTypeServiceQuestionOption(MNVMoveTypeServiceQuestionID);
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteMNVMoveTypeServiceQuestionPreRequisiteDeleteRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvmovetypeservicequestionprerequisiteid = pid;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVMoveTypeServiceQuestionPreRequisite/MNVMoveTypeServiceQuestionPreRequisiteDeleteRecord",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          GetMNVMoveTypeServiceQuestionOption(MNVMoveTypeServiceQuestionID);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidationRoutes() {
    var IsOkay = true;
    if (
      !addEditObjectRoutes.MNVMoveTypeServiceID ||
      addEditObjectRoutes.MNVMoveTypeServiceID == 0
    ) {
      showErrorMessage("Select Service Type");
      IsOkay = false;
    }

    if (IsOkay == true) {
      saveMNVMoveTypeServiceRouteSave();
    }
  }

  function saveMNVMoveTypeServiceRouteSave() {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvmovetypeservicerouteid =
      addEditObjectRoutes.MNVMoveTypeServiceRouteID;
    object.mnvmovetypeserviceid = addEditObjectRoutes.MNVMoveTypeServiceID;
    object.name = addEditObjectRoutes.Name;
    object.description = addEditObjectRoutes.Description;
    object.optionids = addEditObjectRoutes.OptionIDs;
    object.optionoperator = addEditObjectRoutes.OptionOperator;
    object.ptorderby = addEditObjectRoutes.PTOrderBy;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVMoveTypeServiceRoute/MNVMoveTypeServiceRouteSave",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          if (l_response && l_response[0] && l_response[0].Status == 0) {
            showErrorMessage(l_response[0].Message);
          } else {
            setIsAddNewRoutes(0);
            GetMNVMoveTypeServiceQuestion();
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteMNVMoveTypeServiceRouteDeleteRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvmovetypeservicerouteid = pid;
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVMoveTypeServiceRoute/MNVMoveTypeServiceRouteDeleteRecord",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          GetMNVMoveTypeServiceQuestion();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        deleteMNVMoveTypeServiceQuestionData(obj.SelectedID);
      }
    }
    if (obj.ID === 2) {
      if (obj.isConfirm === true) {
        deleteMNVMoveTypeServiceQuestionOptionDeleteRecord(obj.SelectedID);
      }
    }
    if (obj.ID === 3) {
      if (obj.isConfirm === true) {
        deleteMNVMoveTypeServiceQuestionPreRequisiteDeleteRecord(
          obj.SelectedID,
        );
      }
    }
    if (obj.ID === 4) {
      if (obj.isConfirm === true) {
        deleteMNVMoveTypeServiceRouteDeleteRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}

      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {isAddNew == 0 && isAddNewRoutes == 0 && (
        <div className="flex-d justify-btw flex-gap10">
          <div className="flex-da flex-gap10">
            <div className="flex-da flex-gap10">
              <div className="field-input">
                <select
                  className="input-field"
                  value={MNVMoveTypeServiceID}
                  onChange={(e: any) => setMNVMoveTypeServiceID(e.target.value)}
                >
                  <option value={0}>All</option>
                  {gridData[0] &&
                    gridData[0].map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.PID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
            </div>
          </div>
          <div className="com-toggle">
            <span className="txt-compare bold-font">Question View</span>

            {showRouteView == false && (
              <a
                className="com-btn relative-btn p-relative"
                onClick={(e) => setShowRouteView(true)}
              >
                <span></span>
              </a>
            )}
            {showRouteView == true && (
              <a
                className="com-btn com-sel relative-btn p-relative"
                onClick={(e) => setShowRouteView(false)}
              >
                <span></span>
              </a>
            )}
            <span className="txt-compare bold-font">Route View</span>
          </div>
          <div className="flex-d btn-start flex-gap10">
            {showRouteView == false && (
              <a
                className="btn-primary flex-daj btn-grid"
                title="Add New Question"
                onClick={() => {
                  setAddEditObject({
                    MNVMoveTypeServiceQuestionID: 0,
                    MNVMoveTypeServiceID: 0,
                    Name: "",
                    Description: "",
                    PTOrderBy: 0,
                  });
                  setIsAddNew(1);
                }}
              >
                <img src="images/add.svg" width="18" height="18" />
              </a>
            )}
            {showRouteView == true && (
              <a
                className="btn-primary flex-daj btn-grid"
                title="Add New Route"
                onClick={() => {
                  setIsAddNewRoutes(1);
                  setAddEditObjectRoutes({
                    MNVMoveTypeServiceRouteID: 0,
                    MNVMoveTypeServiceID: 0,
                    Name: "",
                    Description: "",
                    OptionIDs: "",
                    OptionOperator: "",
                    PTOrderBy: 0,
                  });
                }}
              >
                <img src="images/add.svg" width="18" height="18" />
              </a>
            )}
          </div>
        </div>
      )}

      {showRouteView == false && (
        <>
          {isAddNew == 0 && (
            <>
              <div className="flow-auto mt-10">
                <table className="reuse-table" id="tblmarketingscore">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Service Name</th>
                      <th>Question</th>
                      <th>Order By</th>
                      <th>Parent Question ID</th>
                      <th className="reuse-tdxs"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {gridData[1] &&
                      gridData[1].map((Item: any, index: any) => (
                        <React.Fragment key={index}>
                          <tr key={index}>
                            <td>{Item.PID}</td>
                            <td>{Item.ServiceName}</td>
                            <td>{Item.Name}</td>
                            <td>{Item.Description}</td>
                            <td>{Item.PTOrderBy}</td>
                            <td className="text-center">
                              <div className="flex-daj gap-10">
                                <a
                                  title="View Options"
                                  onClick={() => {
                                    {
                                      GetMNVMoveTypeServiceQuestionOption(
                                        Item.PID,
                                      );
                                      setSelectedQuestionName(Item.Name);
                                    }
                                  }}
                                >
                                  <img
                                    src="images/info-red.svg"
                                    width="18px"
                                    height="18px"
                                    alt="split"
                                  />
                                </a>
                                <a
                                  onClick={() => {
                                    setIsAddNew(2);
                                    setAddEditObject({
                                      MNVMoveTypeServiceQuestionID:
                                        Item.MNVMoveTypeServiceQuestionID,
                                      MNVMoveTypeServiceID:
                                        Item.MNVMoveTypeServiceID,
                                      Name: Item.Name,
                                      Description: Item.Description,
                                      PTOrderBy: Item.PTOrderBy,
                                    });
                                  }}
                                >
                                  <img
                                    src="images/edit.svg"
                                    width="18px"
                                    height="18px"
                                    alt="Edit"
                                  />
                                </a>
                                <a
                                  onClick={() =>
                                    globalState.setConfirmationModalObject({
                                      ShowPopup: true,
                                      Heading: "Alert",
                                      Message:
                                        "Are your sure, you want to delete this record?",
                                      ID: 1,
                                      SelectedID:
                                        Item.MNVMoveTypeServiceQuestionID,
                                      OtherID: 0,
                                    })
                                  }
                                >
                                  <img
                                    src="images/delete.png"
                                    width="18px"
                                    height="18px"
                                    alt="Delete"
                                  />
                                </a>
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                  </tbody>
                </table>
              </div>{" "}
            </>
          )}

          {(isAddNew == 1 || isAddNew == 2) && (
            <div className="inline-block-d text-center width-100 reuse-border p-all20">
              <>
                <div className="grid-d fr-111 gap-20">
                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">
                      Question Type:
                    </span>
                    <select
                      className="input-field w-100"
                      value={addEditObject.MNVMoveTypeServiceID}
                      onChange={(e) =>
                        setAddEditObject((prevState: any) => ({
                          ...prevState,
                          MNVMoveTypeServiceID: e.target.value,
                        }))
                      }
                    >
                      <option value={0}>Select</option>
                      {gridData[0] &&
                        gridData[0].map((item: any, index: any) => (
                          <React.Fragment key={index}>
                            <option value={item.PID}>{item.Name}</option>
                          </React.Fragment>
                        ))}
                    </select>
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">Name:</span>
                    <input
                      className="input-field w-100"
                      value={addEditObject.Name}
                      onChange={(e) =>
                        setAddEditObject((prevState: any) => ({
                          ...prevState,
                          Name: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Order By:
                    </span>
                    <input
                      className="input-field w-100"
                      value={addEditObject.Description}
                      onChange={(e) =>
                        setAddEditObject((prevState: any) => ({
                          ...prevState,
                          Description: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Parent Question ID:
                    </span>
                    <input
                      className="input-field w-100"
                      type="number"
                      value={addEditObject.PTOrderBy}
                      onChange={(e) =>
                        setAddEditObject((prevState: any) => ({
                          ...prevState,
                          PTOrderBy: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
                <div className="flex-daj gap-10 mt-20">
                  <div className="flex-daj btn-start">
                    <a
                      className="btn-primary flex-daj"
                      onClick={() => checkValidation()}
                    >
                      {isAddNew == 1 ? "Save" : "Update"}
                    </a>
                  </div>
                  <div className="flex-daj btn-start">
                    <a
                      className="btn-primary flex-daj"
                      onClick={() => setIsAddNew(0)}
                    >
                      Cancel
                    </a>
                  </div>
                </div>
              </>
            </div>
          )}
        </>
      )}

      {showRouteView == true && (
        <>
          {isAddNewRoutes == 0 && (
            <>
              <div className="flow-auto mt-10">
                <table className="reuse-table" id="tblmarketingscore">
                  <thead>
                    <tr>
                      <th>Service Name</th>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Option IDs</th>
                      <th>Option Operator</th>
                      <th>Order By</th>
                      <th className="reuse-tdxs"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {gridData[2] &&
                      gridData[2].map((Item: any, index: any) => (
                        <React.Fragment key={index}>
                          <tr key={index}>
                            <td>{Item.ServiceName}</td>
                            <td>{Item.Name}</td>
                            <td>{Item.Description}</td>
                            <td>{Item.OptionIDs}</td>
                            <td>{Item.OptionOperator}</td>
                            <td>{Item.PTOrderBy}</td>
                            <td className="text-center">
                              <div className="flex-daj gap-10">
                                <a
                                  onClick={() => {
                                    setIsAddNewRoutes(2);
                                    setAddEditObjectRoutes({
                                      MNVMoveTypeServiceRouteID:
                                        Item.MNVMoveTypeServiceRouteID,
                                      MNVMoveTypeServiceID:
                                        Item.MNVMoveTypeServiceID,
                                      Name: Item.Name,
                                      Description: Item.Description,
                                      OptionIDs: Item.OptionIDs,
                                      OptionOperator: Item.OptionOperator,
                                      PTOrderBy: Item.PTOrderBy,
                                    });
                                  }}
                                >
                                  <img
                                    src="images/edit.svg"
                                    width="18px"
                                    height="18px"
                                    alt="Edit"
                                  />
                                </a>
                                <a
                                  onClick={() =>
                                    globalState.setConfirmationModalObject({
                                      ShowPopup: true,
                                      Heading: "Alert",
                                      Message:
                                        "Are your sure, you want to delete this record?",
                                      ID: 4,
                                      SelectedID:
                                        Item.MNVMoveTypeServiceRouteID,
                                      OtherID: 0,
                                    })
                                  }
                                >
                                  <img
                                    src="images/delete.png"
                                    width="18px"
                                    height="18px"
                                    alt="Delete"
                                  />
                                </a>
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                  </tbody>
                </table>
              </div>{" "}
            </>
          )}

          {(isAddNewRoutes == 1 || isAddNewRoutes == 2) && (
            <div className="inline-block-d text-center width-100 reuse-border p-all20">
              <>
                <div className="grid-d fr-111 gap-20">
                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">
                      Service Type:
                    </span>
                    <select
                      className="input-field w-100"
                      value={addEditObjectRoutes.MNVMoveTypeServiceID}
                      onChange={(e) =>
                        setAddEditObjectRoutes((prevState: any) => ({
                          ...prevState,
                          MNVMoveTypeServiceID: e.target.value,
                        }))
                      }
                    >
                      <option value={0}>Select</option>
                      {gridData[0] &&
                        gridData[0].map((item: any, index: any) => (
                          <React.Fragment key={index}>
                            <option value={item.PID}>{item.Name}</option>
                          </React.Fragment>
                        ))}
                    </select>
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">Name:</span>
                    <input
                      className="input-field w-100"
                      value={addEditObjectRoutes.Name}
                      onChange={(e) =>
                        setAddEditObjectRoutes((prevState: any) => ({
                          ...prevState,
                          Name: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Description:
                    </span>
                    <input
                      className="input-field w-100"
                      value={addEditObjectRoutes.Description}
                      onChange={(e) =>
                        setAddEditObjectRoutes((prevState: any) => ({
                          ...prevState,
                          Description: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Option IDs:
                    </span>
                    <input
                      className="input-field w-100"
                      value={addEditObjectRoutes.OptionIDs}
                      onChange={(e) =>
                        setAddEditObjectRoutes((prevState: any) => ({
                          ...prevState,
                          OptionIDs: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Option Operator:
                    </span>
                    <input
                      className="input-field w-100"
                      value={addEditObjectRoutes.OptionOperator}
                      onChange={(e) =>
                        setAddEditObjectRoutes((prevState: any) => ({
                          ...prevState,
                          OptionOperator: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Order By:
                    </span>
                    <input
                      className="input-field w-100"
                      type="number"
                      value={addEditObjectRoutes.PTOrderBy}
                      onChange={(e) =>
                        setAddEditObjectRoutes((prevState: any) => ({
                          ...prevState,
                          PTOrderBy: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
                <div className="flex-daj gap-10 mt-20">
                  <div className="flex-daj btn-start">
                    <a
                      className="btn-primary flex-daj"
                      onClick={() => checkValidationRoutes()}
                    >
                      {isAddNewRoutes == 1 ? "Save" : "Update"}
                    </a>
                  </div>
                  <div className="flex-daj btn-start">
                    <a
                      className="btn-primary flex-daj"
                      onClick={() => setIsAddNewRoutes(0)}
                    >
                      Cancel
                    </a>
                  </div>
                </div>
              </>
            </div>
          )}
        </>
      )}

      {showModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner md-popup">
              <div className="help-head flex-da justify-btw">
                <h5 className="bold-font flex-d m-all0">
                  {selectedQuestionName}{" "}
                </h5>
                <a className="close-help" onClick={() => setShowModal(false)}>
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>

              <div className="flex-d btn-start flex-gap10">
                <h5>Question Options</h5>
                {isAddNewOptions == 0 && isAddNewPreRequisite == 0 && (
                  <a
                    className="btn-primary flex-daj btn-grid"
                    title="Add New Option"
                    onClick={() => {
                      setAddEditObjectOptions({
                        MNVMoveTypeServiceQuestionOption: 0,
                        MNVMoveTypeServiceQuestionID: 0,
                        Name: "",
                        PTOrderBy: 0,
                      });
                      setIsAddNewOptions(1);
                    }}
                  >
                    <img src="images/add.svg" width="18" height="18" />
                  </a>
                )}
              </div>

              {isAddNewOptions == 0 && (
                <div className="flow-auto-lg mt-10">
                  <table className="reuse-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Order By</th>
                        <th></th>
                      </tr>
                    </thead>

                    <tbody>
                      {gridDataOptions[0] &&
                        gridDataOptions[0].map((Row: any, index: any) => (
                          <tr key={index}>
                            <td>{Row.PID}</td>
                            <td>{Row.Name}</td>
                            <td>{Row.PTOrderBy}</td>
                            <td className="text-center">
                              <div className="flex-daj gap-10">
                                <a
                                  onClick={() => {
                                    setIsAddNewOptions(2);
                                    setAddEditObjectOptions({
                                      MNVMoveTypeServiceQuestionOptionID:
                                        Row.MNVMoveTypeServiceQuestionOptionID,
                                      MNVMoveTypeServiceQuestionID:
                                        Row.MNVMoveTypeServiceQuestionID,
                                      Name: Row.Name,
                                      PTOrderBy: Row.PTOrderBy,
                                    });
                                  }}
                                >
                                  <img
                                    src="images/edit.svg"
                                    width="18px"
                                    height="18px"
                                    alt="Edit"
                                  />
                                </a>
                                <a
                                  onClick={() =>
                                    globalState.setConfirmationModalObject({
                                      ShowPopup: true,
                                      Heading: "Alert",
                                      Message:
                                        "Are your sure, you want to delete this record?",
                                      ID: 2,
                                      SelectedID:
                                        Row.MNVMoveTypeServiceQuestionOptionID,
                                      OtherID: 0,
                                    })
                                  }
                                >
                                  <img
                                    src="images/delete.png"
                                    width="18px"
                                    height="18px"
                                    alt="Delete"
                                  />
                                </a>
                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}

              {(isAddNewOptions == 1 || isAddNewOptions == 2) && (
                <div className="inline-block-d text-center width-100 reuse-border p-all20">
                  <>
                    <div className="grid-d fr-111 gap-20">
                      <div className="field-input grid-d flex-gap3">
                        <span className="font-12 text-left label-color">
                          Name:
                        </span>
                        <input
                          className="input-field w-100"
                          value={addEditObjectOptions.Name}
                          onChange={(e) =>
                            setAddEditObjectOptions((prevState: any) => ({
                              ...prevState,
                              Name: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div className="field-input grid-d flex-gap3">
                        <span className="font-12 text-left label-color">
                          Order By:
                        </span>
                        <input
                          className="input-field w-100"
                          type="number"
                          value={addEditObjectOptions.PTOrderBy}
                          onChange={(e) =>
                            setAddEditObjectOptions((prevState: any) => ({
                              ...prevState,
                              PTOrderBy: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  </>
                </div>
              )}

              <div className="flex-d  btn-start flex-gap10">
                <h5>Questions Pre Requisite</h5>
                {isAddNewPreRequisite == 0 && isAddNewOptions == 0 && (
                  <a
                    className="btn-primary flex-daj btn-grid"
                    title="Add New Pre Requisite"
                    onClick={() => {
                      setAddEditObjectPreRequisite({
                        MNVMoveTypeServiceQuestionPreRequisiteID: 0,
                        MNVMoveTypeServiceQuestionID: 0,
                        Name: "Name",
                        Description: "Description",
                        OptionIDs: "",
                        OptionOperator: "",
                        PTOrderBy: 0,
                      });
                      setIsAddNewPreRequisite(1);
                    }}
                  >
                    <img src="images/add.svg" width="18" height="18" />
                  </a>
                )}
              </div>

              {isAddNewPreRequisite == 0 && (
                <div className="flow-auto-lg mt-10">
                  <table className="reuse-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Option IDs</th>
                        <th>Option Operator</th>
                        <th>Order By</th>
                        <th></th>
                      </tr>
                    </thead>

                    <tbody>
                      {gridDataOptions[1] &&
                        gridDataOptions[1].map((Row: any, index: any) => (
                          <tr key={index}>
                            <td>{Row.Name}</td>
                            <td>{Row.Description}</td>
                            <td>{Row.OptionIDs}</td>
                            <td>{Row.OptionOperator}</td>
                            <td>{Row.PTOrderBy}</td>
                            <td className="text-center">
                              <div className="flex-daj gap-10">
                                <a
                                  onClick={() => {
                                    setIsAddNewPreRequisite(2);
                                    setAddEditObjectPreRequisite({
                                      MNVMoveTypeServiceQuestionPreRequisiteID:
                                        Row.MNVMoveTypeServiceQuestionPreRequisiteID,
                                      MNVMoveTypeServiceQuestionID:
                                        Row.MNVMoveTypeServiceQuestionID,
                                      Name: Row.Name,
                                      Description: Row.Description,
                                      OptionIDs: Row.OptionIDs,
                                      OptionOperator: Row.OptionOperator,
                                      PTOrderBy: Row.PTOrderBy,
                                    });
                                  }}
                                >
                                  <img
                                    src="images/edit.svg"
                                    width="18px"
                                    height="18px"
                                    alt="Edit"
                                  />
                                </a>
                                <a
                                  onClick={() =>
                                    globalState.setConfirmationModalObject({
                                      ShowPopup: true,
                                      Heading: "Alert",
                                      Message:
                                        "Are your sure, you want to delete this record?",
                                      ID: 3,
                                      SelectedID:
                                        Row.MNVMoveTypeServiceQuestionPreRequisiteID,
                                      OtherID: 0,
                                    })
                                  }
                                >
                                  <img
                                    src="images/delete.png"
                                    width="18px"
                                    height="18px"
                                    alt="Delete"
                                  />
                                </a>
                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}

              {(isAddNewPreRequisite == 1 || isAddNewPreRequisite == 2) && (
                <div className="inline-block-d text-center width-100 reuse-border p-all20">
                  <>
                    <div className="grid-d fr-111 gap-20">
                      <div className="field-input grid-d flex-gap3">
                        <span className="font-12 text-left label-color">
                          Name:
                        </span>
                        <input
                          className="input-field w-100"
                          value={addEditObjectPreRequisite.Name}
                          onChange={(e) =>
                            setAddEditObjectPreRequisite((prevState: any) => ({
                              ...prevState,
                              Name: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div className="field-input grid-d flex-gap3">
                        <span className="font-12 text-left label-color">
                          Description:
                        </span>
                        <input
                          className="input-field w-100"
                          value={addEditObjectPreRequisite.Description}
                          onChange={(e) =>
                            setAddEditObjectPreRequisite((prevState: any) => ({
                              ...prevState,
                              Description: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div className="field-input grid-d flex-gap3">
                        <span className="font-12 text-left label-color">
                          Option IDs:
                        </span>
                        <input
                          className="input-field w-100"
                          value={addEditObjectPreRequisite.OptionIDs}
                          onChange={(e) =>
                            setAddEditObjectPreRequisite((prevState: any) => ({
                              ...prevState,
                              OptionIDs: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div className="field-input grid-d flex-gap3">
                        <span className="font-12 text-left label-color">
                          Option Operator:
                        </span>
                        <input
                          className="input-field w-100"
                          value={addEditObjectPreRequisite.OptionOperator}
                          onChange={(e) =>
                            setAddEditObjectPreRequisite((prevState: any) => ({
                              ...prevState,
                              OptionOperator: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div className="field-input grid-d flex-gap3">
                        <span className="font-12 text-left label-color">
                          Order By:
                        </span>
                        <input
                          className="input-field w-100"
                          type="number"
                          value={addEditObjectPreRequisite.PTOrderBy}
                          onChange={(e) =>
                            setAddEditObjectPreRequisite((prevState: any) => ({
                              ...prevState,
                              PTOrderBy: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  </>
                </div>
              )}

              <div className="flex-daj gap-10 mt-20">
                <div className="flex-daj btn-start">
                  {(isAddNewOptions == 1 || isAddNewOptions == 2) && (
                    <>
                      <a
                        className="btn-primary flex-daj"
                        onClick={() => checkValidationOptions()}
                      >
                        {isAddNewOptions == 1 ? "Save" : "Update"}
                      </a>
                      <a
                        className="btn-primary flex-daj"
                        onClick={() => setIsAddNewOptions(0)}
                      >
                        Cancel
                      </a>
                    </>
                  )}
                  {(isAddNewPreRequisite == 1 || isAddNewPreRequisite == 2) && (
                    <>
                      <a
                        className="btn-primary flex-daj"
                        onClick={() => checkValidationPreRequisite()}
                      >
                        {isAddNewPreRequisite == 1 ? "Save" : "Update"}
                      </a>
                      <a
                        className="btn-primary flex-daj"
                        onClick={() => setIsAddNewPreRequisite(0)}
                      >
                        Cancel
                      </a>
                    </>
                  )}
                  {isAddNewPreRequisite == 0 && isAddNewOptions == 0 && (
                    <a
                      className="btn-primary flex-daj"
                      onClick={() => setShowModal(false)}
                    >
                      Close
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MoveTypeServiceQuestionOption;
